import React from "react";
import { motion } from "framer-motion";

export default function ProgressBar({ value = 0, max = 100, color = "#58CC02", testId = "progress-bar" }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div data-testid={testId} className="w-full bg-gray-200 rounded-full h-4 overflow-hidden border-2 border-gray-200">
      <motion.div
        className="h-full rounded-full"
        style={{ background: color }}
        initial={{ width: 0 }}
        animate={{ width: `${pct}%` }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      />
    </div>
  );
}
